import { useContext, useState, useEffect, useRef } from "react";
import { YearContext, useAuthContext } from "../../context/context";
import { fetchVisionBoardLayout, saveVisionBoardLayout } from "../../api";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import Toast from "./Toast";
import PropTypes from "prop-types";
import { useVisionBoard } from "../../context/VisionBoardContext";

const VisionBoard = ({ isDraggable = true, isResizable = true }) => {
  const containerRef = useRef(null);
  const [toast, setToast] = useState({ message: "", type: "" });
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const columns = 6;
  const rows = 4;

  const { layout, setLayout, moodboardFilteredData, isLoading } = useVisionBoard();

  // Enable animations after initial load
  useEffect(() => {
    if (layout && !isLoading) {
      // Wait a brief moment for layout to settle, then enable animations
      const timer = setTimeout(() => {
        setIsInitialLoad(false);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [layout, isLoading]);

  // Track container size so we can compute width & rowHeight
  const [size, setSize] = useState({ width: 1200, height: 800 });
  useEffect(() => {
    if (!containerRef.current) return;
    const obs = new ResizeObserver(([entry]) => {
      setSize({
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      });
    });
    obs.observe(containerRef.current);
    return () => obs.disconnect();
  }, []);

  const rowHeight = Math.floor(size.height / rows);

  const toggleScroll = (value) => {
    console.log("value", value);
    document.body.classList = value ? "overflow-hidden" : "overflow-auto";
  };

  // Don't render GridLayout until layout is ready (prevents images jumping around)
  if (!layout) {
    return <div ref={containerRef} className="relative w-full h-full bg-white" />;
  }

  return (
    <div ref={containerRef} className="relative w-full h-full bg-white">
      {toast.message && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "" })}
        />
      )}
      <GridLayout
        className={`layout ${isInitialLoad ? 'no-animation' : ''}`}
        layout={layout}
        cols={columns}
        rowHeight={rowHeight}
        width={size.width}
        onResizeStart={() => toggleScroll(true)}
        onResizeStop={() => toggleScroll(false)}
        onDragStart={() => toggleScroll(true)}
        onDragStop={() => toggleScroll(false)}
        isDraggable={isDraggable}
        isResizable={isResizable}
        margin={[0, 0]}
        compactType="vertical"
        preventCollision={false}
        onLayoutChange={(newLayout) => {
          if (setLayout) {
            setLayout(newLayout);
          }
        }}
      >
        {moodboardFilteredData.map((goal) => (
          <div
            key={goal.id.toString()}
            className={`relative w-full h-full overflow-hidden ${isDraggable ? 'cursor-grab active:cursor-grabbing' : 'cursor-default'}`}
          >
            <img
              src={goal.img}
              alt={`Goal for ${goal.year}`}
              className="object-cover w-full h-full"
              crossOrigin="anonymous"
            />
          </div>
        ))}
      </GridLayout>
    </div>
  );
};

VisionBoard.propTypes = {
  isDraggable: PropTypes.bool,
  isResizable: PropTypes.bool,
};

export default VisionBoard;
